import { CoreDataDictionaryViewsName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteDataDictionaryViewRequest } from '@api';
import { getCoreDataDictionaryViewsAsyncSlice } from './get';

export const removeCoreDataDictionaryViewSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataDictionaryViewsName,
	state: getCoreDataDictionaryViewsAsyncSlice.asyncState,
	target: (request: DeleteDataDictionaryViewRequest) => (view) => view.id === request.id
});
